<template>
  <b-form-group label="Link Variable">
    <v-select
      v-model="variable"
      :options="variablesLink"
      label="name"
      :reduce="item => item.key"
      placeholder="Select Global Variable Link"
      @input="val => $emit('change', val)"
    />
  </b-form-group>
</template>

<script>
import {mapState} from 'vuex'
import {toJSON} from '@/utils/helpers'

export default {
  name: 'GlobalVariableLink',
  props: {
    selected: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      value: ''
    }
  },
  computed: {
    ...mapState('projects', {
      project: state => state.project
    }),
    variables () {
      const gv = toJSON(this.project.variables)

      if (Array.isArray(gv?.variables)) {
        return gv?.variables
      }

      const object = gv?.variables || {}
      const list = Object.entries(object).map(([key, value]) => ({
        ...value,
        hash: key
      }))

      return list
    },
    variablesLink () {
      return this.variables.filter(variable => variable.type === 'link')
    },
    variable: {
      get () {
        return this.selected?.variable || this.value
      },
      set (val) {
        this.value = val
      }
    }
  }
}
</script>
